import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isExternalHeroActionPath, normalizeHeroActionPath } from '../storefrontHeroActions';
import { isSameNavRoute, scrollToPageTop } from '../navSameRouteClick';

export default function HeroActionLink({ to, className, children }) {
  const location = useLocation();
  const path = normalizeHeroActionPath(to);
  if (!path) return null;

  const onSameRouteClick = (e) => {
    if (isSameNavRoute(location.pathname, path)) {
      e.preventDefault();
      scrollToPageTop({ smooth: true });
    }
  };

  if (isExternalHeroActionPath(path)) {
    const external = /^https?:/i.test(path);
    return (
      <a
        href={path}
        className={className}
        {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={path} className={className} onClick={onSameRouteClick}>
      {children}
    </Link>
  );
}
